/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createActivity.defs.js'
export { main as default } from './createActivity.defs.js'
